import {ClientPage} from "@/entity/ClientPage";
import {CircleManagement} from "@/entity/CircleManagement";
import {Base} from "@/dto/Base";

export class CircleManagementDto {
    public static url = '/api/app/circle';
    public static async queryCircleManagementPageList(clientPage: ClientPage): Promise<CircleManagement[]>{
        const response = await Base.postWithToken(this.url+'/queryCircleManagementPageList',clientPage)as any
        return response.data.records as CircleManagement[]
    }
    public static async insertCircleManagementPageList(circleManagement: CircleManagement){
       const response = await Base.postWithToken(this.url+'/insertCircleManagementPageList',circleManagement) as  any
        return response
    }
}